import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListChargePointCell } from '@app/feature/transaction/transaction-list/transaction-list-charge-point.cell';
import { TransactionListChargePointHeader } from '@app/feature/transaction/transaction-list/transaction-list-charge-point.header';

export const TokenTransactionListChargePointColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['chargePoint']
> = {
  enableSorting: false,
  header: TransactionListChargePointHeader,
  cell: TransactionListChargePointCell,
};
